import React from 'react';
import './Alert.css';

export const Alert = ({ variant = 'info', className = '', children }) => (
  <div className={`ui-alert ui-alert-${variant} ${className}`.trim()}>{children}</div>
);

export default Alert;
